import { render } from "./chart-pie.vue?vue&type=template&id=04588b3a"
import script from "./chart-pie.vue?vue&type=script&lang=js"
export * from "./chart-pie.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__